/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import cn from 'classnames';
import { Popover, PopoverBody } from '@ferris/react/components/popover';

const LegalFooter = ({ str, tooltip }) => {
    const classes = cn('ulx-form', 'ulx-form-footer');
    const options = {
        replace: ({ attribs, name, children }) => {
            if (!attribs) return;
            if (name === 'a') {
                // eslint-disable-next-line consistent-return
                return (
                    <Popover
                        ariaLabel="Interactive button"
                        label={domToReact(children)}
                        popoverSize="fds-popover-sm"
                        showArrow
                        wrapAlone
                        nested
                        textTrigger
                        labelClasses={cn('legal-footer-btn-focus')}
                    >
                        <PopoverBody
                            classes={cn('info-popover')}
                        >
                            {tooltip}
                        </PopoverBody>

                    </Popover>
                );
            }
        }
    };
    return (
        <section className={classes}>
            <span>
                {parse(str, options)}
            </span>
        </section>
    );
};

LegalFooter.propTypes = {
    str: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired
};

export default LegalFooter;
